import { render, staticRenderFns } from "./_timeout.vue?vue&type=template&id=5b22c1e8&"
import script from "./_timeout.vue?vue&type=script&lang=js&"
export * from "./_timeout.vue?vue&type=script&lang=js&"
import style0 from "./_timeout.vue?vue&type=style&index=0&id=5b22c1e8&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports